import React from 'react';
import { Beginners } from './components/Beginners';
import { Bonuses } from './components/Bonuses';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { FloatingElements } from './components/Floating';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { InsidePreview } from './components/InsidePreview';
import { MetaPixel } from './components/MetaPixel';
import { Modules } from './components/Modules';
import { Pricing } from './components/Offers';
import { Pain } from './components/Pain';
import { PurchasePopup } from './components/PurchasePopup';
import { Testimonials } from './components/Testimonials';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-slate-50 text-slate-600 selection:bg-sky-600 selection:text-white" data-id="element-0" data-mp="23vchelmhoy8g">
      <MetaPixel data-id="element-1" data-mp="3ikqy1x7ax04o" />
      <TopBar data-id="element-2" data-mp="3ij668fcdfvai" />
      <main data-id="element-3" data-mp="3ijpcgysnsv8p">
        <Hero data-id="element-4" data-mp="3ihv1ac76whht" />
        <Pain data-id="element-5" data-mp="3mlj8gtrwtb2j" />
        <HowItWorks data-id="element-6" data-mp="3ml14faz09sk2" />
        <Beginners data-id="element-7" data-mp="3mkhn9wh6j873" />
        <Modules data-id="element-8" data-mp="3mjztr7lwj82v" />
        <InsidePreview data-id="element-9" data-mp="3mjg93j4va5l5" />
        <Bonuses data-id="element-10" data-mp="3rcj6y3gog175" />
        <Pricing data-id="element-11" data-mp="3rbzmaezn6ypf" />
        <Guarantee data-id="element-12" data-mp="3rdkisa5iorpx" />
        <Testimonials data-id="element-13" data-mp="3rd19tixuhdo1" />
        <Faq data-id="element-14" data-mp="3relwkmdx3sbc" />
        <FinalCta data-id="element-15" data-mp="5orh0l86u6j" />
      </main>
      <Footer data-id="element-16" data-mp="4wyzymxdckh" />
      <FloatingElements data-id="element-17" data-mp="5gg5d4r3wxg" />
      <PurchasePopup data-id="element-18" data-mp="7suzhf7pr6a" />
      <noscript data-id="element-19" data-mp="2zld259q0hfbj">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-20" data-mp="2zlv7qwykd5w4" />
      </noscript>
    </div>;
}